module.exports = __webpack_public_path__ + "img/PERCENT.9db8fdb3.svg";